var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgReviewStarFilled = function SvgReviewStarFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m35.997 17.342-6.94 7.099 1.64 10.026c.07.438-.1.881-.444 1.143a1.076 1.076 0 0 1-1.173.089l-8.58-4.734-8.579 4.733c-.374.208-.83.174-1.173-.089a1.198 1.198 0 0 1-.443-1.143l1.638-10.026-6.94-7.098a1.21 1.21 0 0 1-.282-1.198c.132-.422.48-.732.9-.796l9.59-1.461 4.29-9.121c.375-.799 1.623-.799 1.998 0l4.29 9.12 9.59 1.462c.42.064.768.373.9.796a1.21 1.21 0 0 1-.282 1.198Z",
    fill: "url(#review-star-filled_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "review-star-filled_svg__a",
    x1: 20.5,
    y1: 4.167,
    x2: 20.5,
    y2: 35.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C7CE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A5CA3"
  })))));
};
export default SvgReviewStarFilled;